document.addEventListener('DOMContentLoaded', () => {
  const heroButton = document.querySelector('[data-hero-scroll]');
  if (!heroButton) return;

  heroButton.addEventListener('click', (event) => {
    event.preventDefault();

    const featuredSection = document.querySelector('.tgl-featured-section');
    if (featuredSection) {
      const header = document.querySelector('.tgl-header');
      const offset = header ? header.offsetHeight : 0;
      const targetPosition = featuredSection.offsetTop - offset;

      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
      return;
    }

    const href = heroButton.getAttribute('href') || '/#featured-products';
    const normalizedHref = href.startsWith('#') ? `/${href}` : href;
    window.location.href = normalizedHref;
  });
});
